<template>
  <div>
    <section>
      <!--工具条-->
      <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
        <el-form :inline="true" :model="souchs" @submit.native.prevent>
          <el-select v-model="value" placeholder="请选择" @change="changeSouch"  style="width:120px;margin-top:2px">
            <el-option v-for="item in optionsSouch" :key="item.value"  
              :label="item.label" :value="item.value">
            </el-option>
          </el-select>
          <el-form-item>
            <el-input v-show="disSouch" v-model="proName" style="width:200px;"  @keyup.enter.native="getUser(1)" clearable></el-input>
          </el-form-item>

          <el-form-item>
            <el-date-picker v-model="LogDate" style="position: relative; top: 2px; width:300px;"
                            type="daterange" size="large" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
          </el-date-picker>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" size="medium" v-on:click="getUser(1)">查询</el-button>

            <el-button type="text" ><a @click="downFile">导出</a></el-button>

          </el-form-item>
        </el-form>
        <!-- <el-tag :key="tag" v-for="tag in dynamicTags" closable 
          :disable-transitions="false" @close="handleClose(tag)"> 
            {{tag}} 
        </el-tag>
        <el-button v-if="dynamicTags!=''" class="button-new-tag" size="small" @click="delTags">清除标签</el-button> -->
      </el-col>

      <!--列表-->
      <el-table  :data="users" highlight-current-row v-loading="listLoading" height="420px"  style="width: 100%;" 
        :header-cell-style="getRowClass" @sort-change="handleSortChange">
        <el-table-column type="index" :index="indexMethod" label="序号" width="80">
          <template slot-scope="scope">
              <span>{{(pageNumber - 1) * pageSize + scope.$index + 1}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="phone" label="账号" min-width="140" sortable="custom" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="name" label="姓名" min-width="100" sortable="custom" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="point" label="积分" min-width="140" sortable="custom" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="registertime" label="注册日期" min-width="180" sortable="custom">
        </el-table-column>
        <el-table-column prop="company" label="企业" min-width="180" sortable="custom" show-overflow-tooltip>
        </el-table-column>
      </el-table>
      <!--工具条-->
      <el-col :span="24" class="toolbar">
        <br/>
        <el-pagination 
          layout="sizes, prev, pager, next"
          :page-sizes="[10, 20, 30, 50,100]"
          :current-page="pageNumber" 
          @current-change="handleCurrentChange" 
          @size-change="handleSizeChange"
          :page-size="pageSize" 
          :total="total" 
          style="float:right;">
        </el-pagination>
      </el-col>

      

      
    </section>
  </div>
</template>
<script>
import { API__code, API_User ,API_Models, API_Admin,API_Menu} from '../../../api/index.js'
import $ from 'jquery'
var date = new Date();
export default {
  data(){
    return {
      downHref:'',
      disSouch:true,
      disTime2:false,
      proName:"",
      dynamicTags: [],
      optionsSouch: [
        {value: '账号',label: '账号'}, 
        {value: '姓名',label: '姓名'},
        {value: '企业',label: '企业'},
        // {value: '开始日期',label: '开始日期'},
        // {value: '结束日期',label: '结束日期'},
      ],
      value: '账号',
      yhlx:[],
      zhlx:[],
      cities:[],
      citiesd: [],
      id:'',
      token:'',
      checkCode:'',
      listLoading:false,
      souchs:{
        phone:'',
        name:'',
        company:'',
        fromtime:''
      },
      LogDate:[],
      orderStr:'',
      orderType:'',
      pageNumber:1,
      pageSize:10,
      total:0,
      users:[],
      
      companyList:[],

      
    }
  },
  methods:{
    handleClose(tag) {
      if(tag == "账号"){
        this.souchs.phone = '';
        if(this.value == "账号"){
          this.proName = '';
        }
      }
      if(tag == "姓名"){
        this.souchs.name = '';
        if(this.value == "姓名"){
          this.proName = '';
        }
      }
      if(tag == "企业"){
        this.souchs.company = '';
        if(this.value == "企业"){
          this.proName = '';
        }
      }
      
      
      if(tag == "开始日期"){
        this.souchs.fromtime ="";
      }
      if(tag == "结束日期"){
        this.souchs.totime ="";
      }
      this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
    },
    delTags:function(){
      this.souchs = {
        name:'',
        phone:'',
        company:''
      };
      this.proName = '';
      this.value = '';
      this.dynamicTags = [];
      this.pageNumber = 1;
      this.getUser();
    },
    changeSouch:function(val){
      this.souchs = {
        name:'',
        phone:'',
        company:''
      };
      // this.disSouch=false;
      // this.disTime2=false;
      // if(val == "账号"){
      //   this.proName = this.souchs.phone;
      //   this.disSouch = true;
      // }else if(val == "姓名"){
      //   this.proName = this.souchs.name;
      //   this.disSouch = true;
      // }else if(val == "企业"){
      //   this.proName = this.souchs.company;
      //   this.disSouch = true;
      // }else if(val == "结束日期"){
      //   this.disTime2 = true;
      // }
    },
    handleSortChange:function(val){
      if(val){
        if(val.prop == "phone"){
          this.orderStr = "phoneOrder";
        }else if(val.prop == "name"){
          this.orderStr = "nameOrder";
        }else if(val.prop == "point"){
          this.orderStr = "pointOrder";
        }else if(val.prop == "userName"){
          this.orderStr = "usertypeOrder";
        }else if(val.prop == "registertime"){
          this.orderStr = "registertimeOrder";
        }else if(val.prop == "company"){
          this.orderStr = "companyOrder";
        }
        if(val.order == "descending"){
          this.orderType = "desc";
        }else{
          this.orderType = "asc";
        }
      }
      this.getUser();
    },
    forType:function(row, column){
      if(row.usertype == 1){
        return row.userType = '企业账号';
      }else {
        return row.userType = '个人账号';
      }
    },
    indexMethod(index) {
      return (index+1)+(this.pageNumber-1)*pageSize;
    },
    getRowClass({ row, column, rowIndex, columnIndex }) {
        if (rowIndex == 0) {
            return "background:#F5F7FA";
        } else {
            return "";
        }
    },
    selsChange: function (sels) {
      this.sels = sels;
    },
    handleCurrentChange(val) {
      this.pageNumber = val;
      this.getUser();
    },
    handleSizeChange(val) {
			this.pageSize = val;
			this.getUser();
		},
    downFile(){
      if(this.value == "账号"){
        this.souchs.phone = this.proName;
      }
      if(this.value == "企业"){
        this.souchs.company = this.proName;
      }
      if(this.value == "姓名"){
        this.souchs.name = this.proName;
      }
      this.downHref = API_User.userListByExcel()+"?token="+this.token+ 
      "&checkCode="+this.checkCode+
      "&dBegin="+this.$moment(this.LogDate[0]).format('YYYY-MM-DD')+
      "&dEnd="+this.$moment(this.LogDate[1]).format('YYYY-MM-DD')+
      "&phone="+this.souchs.phone+
      "&company="+this.souchs.company+
      "&username="+this.souchs.name+"";

      const a = document.createElement('a')

      fetch(this.downHref).then(res => res.blob()).then(blob => { // 将链接地址字符内容转变成blob地址
          a.href = URL.createObjectURL(blob)
          a.download = '日活用户统计' // 下载文件的名字
          document.body.appendChild(a)
          a.click()
      })
    },
    getUser:function(val){
      if(this.value == "账号"){
        this.souchs.phone = this.proName;
      }
      if(this.value == "企业"){
        this.souchs.company = this.proName;
      }
      if(this.value == "姓名"){
        this.souchs.name = this.proName;
      }

      this.downHref = API_User.userListByExcel()+"?token="+this.token+ 
      "&checkCode="+this.checkCode+
      "&dBegin="+this.$moment(this.LogDate[0]).format('YYYY-MM-DD')+
      "&dEnd="+this.$moment(this.LogDate[1]).format('YYYY-MM-DD')+
      "&phone="+this.souchs.phone+
      "&company="+this.souchs.company+
      "&username="+this.souchs.name+"";

      var flag = true;
      if(val == 1){
        this.pageNumber = 1;
        if(this.value){
          if(this.dynamicTags.length > 0){
            for(var i=0;i<this.dynamicTags.length;i++){
              if(this.value == this.dynamicTags[i]){
                flag = false;
              }
            }
          }
          if(flag){
            this.dynamicTags.push(this.value);
          }
        }
      }
      let param = {
        token:this.token,
        checkCode:this.checkCode,
        pageNumber:this.pageNumber,
        pageSize:this.pageSize,
        listType:'page',
        userType:'',
        // searchStr:this.souchs.modelName,
        username:this.souchs.name,
        phone:this.souchs.phone,
        company:this.souchs.company,
        dBegin:this.$moment(this.LogDate[0]).format('YYYY-MM-DD'),
        dEnd:this.$moment(this.LogDate[1]).format('YYYY-MM-DD'),
        //registertimeto:this.souchs.totime,
        
        orderType: this.orderType,
        orderStr: this.orderStr,
      }
      this.listLoading = true
      API_User.userListByDay(param)
      .then((res) =>{
        if(res.data.code == API__code.SUCCESS){
          if(res.data.data){
            for(var i=0;i<res.data.data.list.length;i++){
              res.data.data.list[i].registertimeyuan = res.data.data.list[i].registertime;
              if(res.data.data.list[i].registertime){
                res.data.data.list[i].registertime = res.data.data.list[i].registertime.substring(0,10);
              }
            }
            this.total = res.data.data.totalRow;
            this.users = res.data.data.list;
            this.listLoading = false
          }
        }else{
          this.$message.error(res.data.message);
          if(res.data.code == 403){
            this.$router.push({path: 'loginAdmin'});
          }
        }
      }).catch(err =>{
        this.$message.error('数据丢失，试试重新登陆！');
      });
    },
    getModels:function(){
      let param = {
        token:this.token,
        checkCode:this.checkCode,
      };
      API_Models.getAdminModule(param)
      .then((res) =>{
        if(res.data.code == API__code.SUCCESS){
          this.models = res.data.data;
          this.cities=[];
          this.citiesd = [];
          for(var i =0;i<res.data.data.length;i++){
            this.cities.push(res.data.data[i].modulename);
            var jsones = {"modulename":res.data.data[i].modulename,"id":res.data.data[i].id};
            this.citiesd.push(jsones);
          }
        }else{
          this.$message.error(res.data.message);
          if(res.data.code == 403){
            this.$router.push({path: 'loginAdmin'});
          }
        }
      }).catch(err =>{
        this.$message.error('数据丢失，试试重新登陆！');
      });
    },
    //读取cookie
    getCookie: function() {
        if (document.cookie.length > 0) {
            var arr = document.cookie.split('; '); //这里显示的格式需要切割一下自己可输出看下
            for (var i = 0; i < arr.length; i++) {
                var arr2 = arr[i].split('='); //再次切割
                //判断查找相对应的值
                if (arr2[0] == 'dnnyptadmin_token') {
                    this.token = arr2[1]; //保存到保存数据的地方
                } else if (arr2[0] == 'dnnyptadmin_checkCode') {
                    this.checkCode = arr2[1];
                } else if (arr2[0] == 'dnnyptadmin_id') {
                    this.id = arr2[1];
                }
            }
        }
    },

    getCode1:function(){
      let _this = this;
      let param = {
        token:this.token,
        checkCode:this.checkCode,
      }

      API_Admin.tbCompanyList(param)
      .then((res) =>{
        if(res.data.code == API__code.SUCCESS){
          this.companyList = res.data.data;
          //_this.yhlx=[];
        }
      });
    },
    getCode2:function(){
      let _this = this;
      let param = {
        token:this.token,
        checkCode:this.checkCode,
      }
      API_Admin.AccList(param)
      .then((res) =>{
        if(res.data.code == API__code.SUCCESS){
          _this.zhlx=[];
          for(var i=0;i<res.data.data.length;i++){
            var jsons = {"value":res.data.data[i].code,"text":res.data.data[i].name}
            _this.zhlx.push(jsons);
          }
        }else{
          this.$message.error(res.data.message);
          if(res.data.code == 403){
            this.$router.push({path: 'loginAdmin'});
          }
        }
      });
    },
   
    
  },

  created(){
    let d = new Date();
    let year1, month1, day1
    ;[year1, month1, day1] = [d.getFullYear(), d.getMonth(), d.getDate()]
    let date1 = new Date(year1, month1, day1, 7)
    let year2, month2, day2
    d.setTime(d.getTime() - 30 * 24 * 60 * 60 * 1000)
    ;[year2, month2, day2] = [d.getFullYear(), d.getMonth(), d.getDate()]
    let date2 = new Date(year2, month2, day2, 7)
    this.LogDate = [date2, date1]
    

    this.getCookie();
    this.getCode1();
    this.getCode2();

    if(this.$route.query.type == 1){
      this.dynamicTags = JSON.parse(this.$route.query.dynamicTags);
      this.souchs = JSON.parse(this.$route.query.souchs);
      this.pageNumber = JSON.parse(this.$route.query.pageNumber);
    }
    this.getUser();
    this.getModels();
    
    
  },
  mounted(){
    
    
  },
}
</script>
<style scoped>
.el-select {
    display: inline-block;
    position: relative;
    width: 115px;
}
.el-tag + .el-tag {
    margin-left: 10px;
}

a{
    text-decoration: none;
    color: #2196F3;
  }
</style>


// WEBPACK FOOTER //
// Account.vue?4665d88f